import Keycloak from 'keycloak-js';

const keycloak = new Keycloak({
  url:
    (!window.g_keycloakUrl?.startsWith('%')
      ? window.g_keycloakUrl
      : null) ??
    process.env.REACT_APP_KEYCLOAK_URL ??
    'https://id.addai.cz/auth',
  realm:
    (!window.g_keycloakRealm?.startsWith('%')
      ? window.g_keycloakRealm
      : null) ??
    process.env.REACT_APP_KEYCLOAK_REALM ??
    'addai',
  clientId:
    (!window.g_keycloakClientId?.startsWith('%')
      ? window.g_keycloakClientId
      : null) ??
    process.env.REACT_APP_KEYCLOAK_CLIENT_ID ??
    'training-tool'
});

export default keycloak;
